/**
 * Vault types and defaults for KnowledgeBase
 */
import { slugify } from '../services/LinkParser.js'

export const VAULT_DEFAULTS = {
  name: 'My Notes',
  // Default vault icon (Material Symbols)
  icon: 'folder_data',
  settings: {
    defaultView: 'tree',
    sortBy: 'title',
    sortDirection: 'asc',
    showEmptyFolders: true,
    autoExpandFolders: true,
    autoCreateEntityFolders: true,
    autoCreateWikiNotes: false,
    // New: default permission for newly created notes in this vault
    // Values: 'PRIVATE' | 'PUBLIC' | 'CAMPAIGN' | 'INHERIT' (match vault access)
    defaultNotePermission: 'PRIVATE',
    // New: landing note to open first in public vault view
    defaultLandingNoteId: null,
    defaultLandingNoteSlug: null
  },
  folderMeta: {}
}

/**
 * Create a new vault object with defaults
 * @param {Object} data - Partial vault data
 * @returns {Object} Complete vault object
 */
export function createVault(data = {}) {
  return {
    name: data.name || VAULT_DEFAULTS.name,
    // Use provided icon, otherwise fall back to VAULT_DEFAULTS.icon
    icon: data.icon ?? VAULT_DEFAULTS.icon,
    ownerId: data.ownerId || null,
    // Persisted sharing fields
    access: String(data.access || 'PRIVATE').toUpperCase(),
    campaignIds: Array.isArray(data.campaignIds)
      ? Array.from(new Set(data.campaignIds.filter(Boolean)))
      : [],
    campaignId: data.campaignId || null,
    allowedUserIds: Array.isArray(data.allowedUserIds)
      ? Array.from(new Set(data.allowedUserIds.filter(Boolean)))
      : [],
    // Ensure slug is present; fallback to name for legacy docs without slug
    slug: data.slug || (data.name ? slugify(String(data.name)) : null),
    versionId: data.versionId || null,
    settings: { ...VAULT_DEFAULTS.settings, ...(data.settings || {}) },
    folderMeta: data.folderMeta || {},
    createdAt: data.createdAt || null,
    updatedAt: data.updatedAt || null,
    // Optional moderation counters
    reportsCount: data.reportsCount || 0
  }
}

/**
 * Vault access levels
 */
export const VAULT_ACCESS = {
  PRIVATE: 'PRIVATE', // Only owner
  CAMPAIGN: 'CAMPAIGN', // Campaign members can view
  CAMPAIGN_EDIT: 'CAMPAIGN_EDIT', // Campaign members can edit
  PUBLIC: 'PUBLIC' // Anyone can view
}

export default {
  VAULT_DEFAULTS,
  VAULT_ACCESS,
  createVault
}
